/**
 * Safely decode a URL that may or may not be already encoded
 * Handles S3 URLs with encoded path segments like %2F and %20
 */
export const safeDecodeUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  
  try {
    // Check if URL is already decoded by trying to decode it
    // If decoding changes the URL, it was encoded
    const decoded = decodeURIComponent(url);
    
    // Return the decoded version
    return decoded;
  } catch (error) {
    // If decoding fails, return original URL
    console.warn('Failed to decode URL:', url, error);
    return url;
  }
};

/**
 * Normalize S3 URLs by decoding path segments
 * Example: projects%2Fvideo%2Ffile.mp4 -> projects/video/file.mp4
 */
export const normalizeS3Url = (url: string | null | undefined): string | null => {
  if (!url) return null;
  
  try {
    // Parse the URL to separate the protocol, domain, and path
    const urlObj = new URL(url);
    
    // Decode only the pathname (not the query params)
    urlObj.pathname = decodeURIComponent(urlObj.pathname);
    
    return urlObj.toString();
  } catch (error) {
    // If URL parsing fails, try simple decode
    return safeDecodeUrl(url);
  }
};
